import { down } from 'shared/javascripts/util/breakpoints'

export const mobileBreakpoint = window.matchMedia(down('lg'))
